import { CRM_BOOKS_COMPANY_QUERY_KEY, CrmPage } from "constants/crmPages";

const ADMIN_CRM_BASE_PATH = "/admin/crm";

export const getCrmPageLink = (page: CrmPage, groupId: string): string => {
  if (page.omitUrl) {
    return `${page.url}?${CRM_BOOKS_COMPANY_QUERY_KEY}=${groupId}`;
  }

  return `${ADMIN_CRM_BASE_PATH}/${groupId}${page.url}`;
};
